import React from "react";

interface TrashIconProps {
    width?: number;
    height?: number;
    fillColor?: string;
    strokeColor?: string;
}

const TrashIcon = ({
    width = 24,
    height = 24,
    fillColor = "#3674EE",
    strokeColor = "white",
}: TrashIconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 4V13.625C13 13.9897 12.8495 14.3394 12.5816 14.5973C12.3137 14.8551 11.9503 15 11.5714 15H4.42857C4.04969 15 3.68633 14.8551 3.41842 14.5973C3.15051 14.3394 3 13.9897 3 13.625V4" stroke="#F5004A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 4H14" stroke="#F5004A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 4V2.5C5 2.10218 5.15804 1.72064 5.43934 1.43934C5.72064 1.15804 6.10218 1 6.5 1H9.5C9.89782 1 10.2794 1.15804 10.5607 1.43934C10.842 1.72064 11 2.10218 11 2.5V4" stroke="#F5004A" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default TrashIcon;
